<template>
  <div id="app">
    <transition name="fade">
      <div v-if="authenticated" key="show-app">
        <div class="menu-fixed">
          <ws-nav-bar/>
          <ws-nav-menu v-show="showMenu"/>
        </div>
        <div class="content-spacer"></div>
        <router-view :key="$route.fullPath"/>
      </div>
      <div v-else-if="isInvitedUser" key="show-register">
        <div class="menu-fixed">
          <ws-guest-nav-bar/>
        </div>
        <div class="content-spacer"></div>
        <router-view :key="$route.fullPath"/>
      </div>
      <div v-else key="show-login">
        <ws-login/>
      </div>
    </transition>
  </div>
</template>

<script>
import WsNavBar from '@/views/navigation/NavBar'
import WsGuestNavBar from '@/views/navigation/GuestNavBar'
import WsNavMenu from '@/views/navigation/NavMenu'
import WsLogin from '@/views/login/Login'

import { NAV_GET_MENU_OPEN } from '@/store/navigation/nav.types'
import { AUTH_IS_AUTHENTICATED, AUTH_GET_IS_INVITE } from '@/store/auth/auth.types'

export default {
  name: 'App',
  data () {
    return {}
  },
  methods: {
    getMenuState () {
      return this.$store.getters[NAV_GET_MENU_OPEN]
    }
  },
  computed: {
    showMenu () {
      return this.getMenuState()
    },
    authenticated () {
      // Checking if user is invited by email here
      // because if a registered user was using the same
      // device beforehand the invited user will be logged
      // in as the previous user.
      // Tried purging the auth with AUTH_PURGE_AUTH
      // but that causes a conflict of some sort with
      // AUTH_GET_IS_INVITE because they are kept in the same
      // module.
      if (this.$store.getters[AUTH_GET_IS_INVITE]) {
        return false
      }

      return this.$store.getters[AUTH_IS_AUTHENTICATED]
    },
    isInvitedUser () {
      return this.$store.getters[AUTH_GET_IS_INVITE]
    }
  },
  components: {
    WsNavBar,
    WsGuestNavBar,
    WsNavMenu,
    WsLogin
  }
}
</script>

<style lang="scss">
  @import 'themes/default/scss/application.scss';
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";
  @import "~bootstrap/scss/utilities";

  .menu-fixed {
    top: 0;
    right: 0;
    left: 0;
    z-index: $zindex-fixed;
  }

  // We want the menu to only be fixed on xl displays and up, if we
  // have it fixed on all displays it can't be scrolled up
  // and down if it doesn't fit the device's screen.
  @include media-breakpoint-up(xl) {
    .menu-fixed {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      z-index: $zindex-fixed;
    }
  }

  .content-spacer {
  }

  @include media-breakpoint-up(xl) {
    .content-spacer {
      height: 51px;
      z-index: $zindex-fixed;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue